import {module as Module} from "modujs";
import { ENV } from "../config";

export default class extends Module {
    playVideo() {
        // Start the animation
        if (this.isPlaying) return;
        this.isPlaying = true;
        this.el.play();
    }

    pauseVideo() {
        // Pause the animation
        if (!this.isPlaying) return;
        this.isPlaying = false;
        this.el.pause();
    }

    toggleVideo(e) {
        if(ENV.PREFERS_REDUCED_MOTION) return

        const {way} = e;
        if (way === "enter") {
            this.playVideo();
        } else {
            this.pauseVideo();
        }
    }
}
